export default __webpack_public_path__ + "./fonts/xlsx.a89baac7.svg";